import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUrgent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 13 13",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Artboard" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "time-countdown-copy-2",
				transform: "translate(0.400000, 1.500000)",
				stroke: "currentColor",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M5.31776638,1.31921162 L3.49958457,1.31921162 L3.99958457,1.81921162 C3.99958457,1.59327695 4.1827408,1.41012071 4.40867547,1.41012071 C4.63461014,1.41012071 4.81776638,1.59327695 4.81776638,1.81921162 L5.31776638,1.81921162 L5.31776638,1.31921162 Z",
						id: "Oval-4-Copy-2",
						transform: "translate(4.408675, 1.364666) rotate(-37.000000) translate(-4.408675, -1.364666) "
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M12.1359482,1.31921162 L10.3177664,1.31921162 L10.8177664,1.81921162 C10.8177664,1.59327695 11.0009226,1.41012071 11.2268573,1.41012071 C11.452792,1.41012071 11.6359482,1.59327695 11.6359482,1.81921162 L12.1359482,1.81921162 L12.1359482,1.31921162 Z",
						id: "Oval-4-Copy-3",
						transform: "translate(11.226857, 1.364666) scale(-1, 1) rotate(-37.000000) translate(-11.226857, -1.364666) "
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						strokeLinecap: "square",
						cx: 7.95454545,
						cy: 5.68181818,
						r: 4.09090909
					}),
					/* @__PURE__ */ _jsx("polyline", {
						id: "Shape",
						strokeLinecap: "round",
						points: "7.95454545 3.40909091 7.95454545 5.68181818 9.31818182 6.59090909"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M6.59090909,0.227272727 L9.31818182,0.227272727",
						id: "Shape",
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M7.95454545,0.227272727 L7.95454545,1.59090909",
						id: "Shape",
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M1.22935538,4.09090909 L3.18181818,4.09090909",
						id: "Shape",
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M0.170881953,5.90909091 L2.82828283,5.90909091",
						id: "Shape",
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M0.877049655,7.72727273 L3.18181818,7.72727273",
						id: "Shape",
						strokeLinecap: "round"
					})
				]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgUrgent);
export default ForwardRef;
